import { render, staticRenderFns } from "./historicalReference.vue?vue&type=template&id=1f0f3142&scoped=true&"
import script from "./historicalReference.vue?vue&type=script&lang=js&"
export * from "./historicalReference.vue?vue&type=script&lang=js&"
import style0 from "./historicalReference.vue?vue&type=style&index=0&id=1f0f3142&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0f3142",
  null
  
)

export default component.exports